import imageCreek from "../../common/assets/bgCreek.png";
import imageNuevamente from "../../common/assets/bgNuevamente.png";
import imageHangover from "../../common/assets/bgHangover.png";
import imageLeparc from "../../common/assets/bgLeparc.png";
import imageKeops from "../../common/assets/bgKeops.png";
import imageQuickpass from "../../common/assets/bgQuickpass.png";
import imageRosario from "../../common/assets/bgRosario.png";
import imageWabi from "../../common/assets/bgWabi.png";


let bgLoginImage = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    bgLoginImage = imageCreek;
}else if (tenantId == "nuevamente") {
    bgLoginImage = imageNuevamente;
}else if (tenantId == "leparc") {
    bgLoginImage = imageLeparc;
}else if (tenantId == "hangover") {
    bgLoginImage = imageHangover;
}else if (tenantId == "keops") {
    bgLoginImage = imageKeops;
}else if (tenantId == "quickpass") {
    bgLoginImage = imageQuickpass;
}else if (tenantId == "rosario") {
    bgLoginImage = imageRosario;
}else if (tenantId == "wabi") {
    bgLoginImage = imageWabi;
}



export default bgLoginImage;


// WEBPACK FOOTER //
// ./src/screens/login/LoginImageSelector.js